module.exports = __webpack_public_path__ + "img/type_moving-floor_link.bd57771f.png";